// 校验ds变量名的合法性
export const dsNameRegexp = /^[a-zA-Z]+[a-zA-Z0-9]+$/;
